// deps
import React, { memo, ReactElement } from "react";
import { withStyles } from "@swiggy-private/core-ui";
import {
    OrderContainer,
    SingleLine,
    Circle,
    LineShimmer,
    PaymentMethodContainer,
    PaymentMethodRow,
    Square,
    Rectangle,
    TitleShimmer,
    Row,
} from "./style";

// test-ids
import { LOADING_SCREEN_TEST_IDS } from "@swiggy-private/payment-test-ids";

interface InitalLoadingScreenProps {
    className?: string;
}

const LoadingLine = memo(function LoadingLine({ lineWidth = 50 }: { lineWidth?: number }): ReactElement {
    return (
        <SingleLine>
            <Circle />
            <LineShimmer widthPercent={lineWidth} />
        </SingleLine>
    );
});

const PaymentMethodRowComp = memo(function PaymentMethodRowComp(): ReactElement {
    return (
        <PaymentMethodRow>
            <Square />
            <LineShimmer widthPercent={52} />
            <LineShimmer widthPercent={10} />
        </PaymentMethodRow>
    );
});

const Title = memo(function Title({ lineWidth = 30 }: { lineWidth?: number }): ReactElement {
    return <TitleShimmer widthPercent={lineWidth} />;
});

function InitalLoadingScreen(props: InitalLoadingScreenProps): ReactElement {
    return (
        <>
            <OrderContainer className={props.className} data-testid={LOADING_SCREEN_TEST_IDS.CONTAINER}>
                <LoadingLine lineWidth={75} />
                <LoadingLine lineWidth={90} />
            </OrderContainer>

            <Title lineWidth={30} />

            <PaymentMethodContainer>
                <PaymentMethodRowComp />
                <PaymentMethodRowComp />
                <PaymentMethodRowComp />
                <PaymentMethodRowComp />
            </PaymentMethodContainer>

            <Title lineWidth={50} />

            <PaymentMethodContainer>
                <Rectangle />
                <Row>
                    <LineShimmer widthPercent={70} />
                    <LineShimmer widthPercent={20} />
                </Row>

                <Row>
                    <LineShimmer widthPercent={70} />
                    <LineShimmer widthPercent={20} />
                </Row>
            </PaymentMethodContainer>
        </>
    );
}

export default memo(withStyles<InitalLoadingScreenProps>(InitalLoadingScreen));
